"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastDefaultExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/toast/examples/default.ts';
var AppToaster = new _1.Toaster();
var ToastDefaultExample = /** @class */ (function () {
    function ToastDefaultExample() {
        var _this = this;
        this.clearOnEscapeKey = true;
        this.icon = true;
        this.inline = false;
        this.position = 'top';
        this.timeout = 3000;
        this.show = function () {
            AppToaster.show({
                message: "Timestamp: ".concat(Date.now()),
                icon: _this.icon ? _1.Icons.ALERT_TRIANGLE : undefined,
                intent: _this.intent,
                size: _this.size,
                timeout: _this.timeout
            });
        };
        this.updateFirst = function () {
            var toast = AppToaster.getToasts()[0];
            AppToaster.update(toast.key, {
                message: 'UPDATED MESSAGE',
                intent: 'primary'
            });
        };
        this.dismissFirst = function () {
            var toast = AppToaster.getToasts()[0];
            AppToaster.dismiss(toast.key, false);
        };
    }
    ToastDefaultExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), direction: 'column', src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Button, {
                label: 'Show Toast',
                onclick: this.show,
                intent: 'primary',
                style: 'margin-bottom: 10px'
            }),
            (0, mithril_1.default)(_1.Button, {
                label: 'Update first',
                onclick: this.updateFirst,
                disabled: AppToaster.getToasts().length === 0,
                style: 'margin-bottom: 10px'
            }),
            (0, mithril_1.default)(_1.Button, {
                label: 'Remove first',
                onclick: this.dismissFirst,
                disabled: AppToaster.getToasts().length === 0
            }),
            (0, mithril_1.default)(AppToaster, {
                clearOnEscapeKey: this.clearOnEscapeKey,
                inline: this.inline,
                position: this.position
            })
        ]);
    };
    ToastDefaultExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Position'),
            (0, mithril_1.default)(_1.Select, {
                options: Object.keys(_1.ToasterPosition).map(function (key) { return _1.ToasterPosition[key]; }),
                onchange: function (e) { return _this.position = e.target.value; },
                size: 'xs'
            }),
            (0, mithril_1.default)('h5', 'Size'),
            (0, mithril_1.default)(examples_1.SizeSelect, { onSelect: function (size) { return _this.size = size; } }),
            (0, mithril_1.default)('h5', 'Intent'),
            (0, mithril_1.default)(examples_1.IntentSelect, { onSelect: function (intent) { return _this.intent = intent; } }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.clearOnEscapeKey,
                label: 'Clear on ESC key',
                onchange: function () { return _this.clearOnEscapeKey = !_this.clearOnEscapeKey; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.inline,
                label: 'Inline',
                onchange: function () { return _this.inline = !_this.inline; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.icon,
                label: 'Icon',
                onchange: function () { return _this.icon = !_this.icon; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.timeout === 0,
                label: 'Timeout = 0',
                onchange: function () { return _this.timeout = _this.timeout === 0 ? 3000 : 0; }
            })
        ];
    };
    return ToastDefaultExample;
}());
exports.ToastDefaultExample = ToastDefaultExample;
